import Flickity from 'flickity';
import IMask from 'imask';
import NiceSelect from 'nice-select2/dist/js/nice-select2';
import * as ScrollMagic from 'scrollmagic';
import { gsap, TweenMax, TimelineMax } from 'gsap';
import { ScrollMagicPluginGsap, ScrollMagicPluginIndicator } from 'scrollmagic-plugins';
import FormData from 'form-data';
import axios from 'axios';
import i18next from "./i18nextLocales/i18n";
import {generateError} from "./validateForm";
import * as Sentry from '@sentry/browser';
import env from './.env_js.json';

const { siteRecaptchaKey, sentryDsn } = env;

Sentry.init({
	dsn: sentryDsn,
	maxBreadcrumbs: 50,
	debug: true,
	beforeSend (event, hint) {
		if (event.exception) {
			console.error(`[Exeption handled by Sentry]: (${hint.originalException})`, { event, hint });
		}
		if (hint.originalException === 'Timeout') { return null; } // todo sentry check recapcha module
		// Continue sending to Sentry
		return event;
	},
});

ScrollMagicPluginIndicator(ScrollMagic);
ScrollMagicPluginGsap(ScrollMagic, TweenMax, TimelineMax);

let autoResize;
window.addEventListener('resize', function () {
	clearTimeout(autoResize);
	autoResize = setTimeout(headerFixedClass, 400);
	autoResize = setTimeout(statisticsSlider, 400);
	autoResize = setTimeout(preferenceSlide, 400);
	autoResize = setTimeout(servicesSlider, 400);
});

document.addEventListener('DOMContentLoaded', initPage);

async function initPage() {
	mobileMenu();
	toggleMenuItem();
	headerFixedClass();
	formEffect();
	anchor();
	tabs();
    dropdownBlock();
	blockToTop(document.querySelector('.stages-selection'));
	// showStages();

	const feedbackFormSubmit = document.querySelector('.request__form');
	if (feedbackFormSubmit) {
		// eslint-disable-next-line consistent-return
		feedbackFormSubmit.addEventListener('submit', function (e) {
			e.preventDefault();
			let formFields = [];
			formFields = feedbackFormSubmit.querySelectorAll('.js-field:not(.nice-select)');

			for (const fieldControl of formFields) {
				if (!fieldControl.value) {
					return false;
				}
			}

			const data = new FormData();
			data.append('order_type_id', document.querySelector('.select__box [data-class="select_js"]').selectedIndex);
			data.append('name', document.querySelector('.form__control[name="name"]').value);
			data.append('email', document.querySelector('.form__control[name="email"]').value);
			data.append('phone', document.querySelector('.form__control[name="phone"]').value);

			const config = {
				method: 'post',
				url: e.target.getAttribute('action'),
				headers: {
					Accept: 'application/json',
					'Content-Type': 'application/json',
				},
				data: data,
			};
			getDataPost(config);
		});
	}

	function getDataPost(config) {
		feedbackFormSubmit.querySelector('button[type="submit"]').classList.add('loading');
		const sendPostRequest = async () => {
			try {
				const response = await axios(config);
				if (response.data.status === 200) {
					window.location.replace(response.data.redirect);
				}
			} catch (error) {
				console.log(error);
				if (error.response.status === 422) {
					const errors = error.response.data?.errors;
					const fieldsEl = [];
					fieldsEl.push(document.querySelectorAll('.js-field:not(.nice-select)'));
					fieldsEl.filter((field) => field.forEach((fieldName) => {
						console.log(!!errors[fieldName.getAttribute('name')] && errors[fieldName.getAttribute('name')].length > 0);
						if (!!errors[fieldName.getAttribute('name')] && errors[fieldName.getAttribute('name')].length > 0) {
							const status = fieldName.value;
							const error = generateError('');
							if (fieldName.parentElement.querySelector('.error') == null) {
								fieldName.parentElement.prepend(error);
							}
							// eslint-disable-next-line no-param-reassign
							fieldName.parentElement.querySelector('.error').innerHTML = i18next.t('field_filled_incorrectly');
							fieldName.parentElement.classList.add('form__box_error');
							fieldName.parentElement.classList.remove('form__box_valid');
						}
					}));
				}
				if (error.response.status === 419) {
					feedbackFormSubmit.querySelector('.app-error').innerHTML = i18next.t('Оновіть сторінку та спробуйте ще раз');
					feedbackFormSubmit.querySelector('.app-error').closest('.form__box').classList.add('form__box_error');
				}
			} finally {
				feedbackFormSubmit.querySelector('button[type="submit"]').classList.remove('loading');
			}
		};
		return sendPostRequest();
	}
}

if (document.querySelector('#next') && window.innerWidth >= 991) {
// init controller
	const monitor = window.innerHeight;
	const controller = new ScrollMagic.Controller();
	// eslint-disable-next-line no-unused-vars
	const scence = new ScrollMagic.Scene({
		triggerElement: '#next', duration: 800, offset: -50, triggerHook: 1,
	})
		.setTween('#next2', {})
	// .addIndicators({ name: '2 (duration: 300)' })
		.on('progress', function (e) {
			// const progress = document.querySelector('#progress');
			const next2 = document.querySelector('#next2');
			// progress.innerHTML = e.progress.toFixed(3);
			if (e.progress.toFixed(3) >= 1) {
				next2.classList.add('end');
			} else {
				next2.classList.remove('end');
			}

			gsap.to(next2, {
				'--y': `${(e.progress.toFixed(3) * 100)}%`,
				'--y-reverse': `${(100 - (e.progress.toFixed(10) * 100))}vh`,
				duration: 0.1,
				ease: 'linear',
			});
		})
		.addTo(controller);

	const controller2 = new ScrollMagic.Controller();
	const tween = new TimelineMax();
	// eslint-disable-next-line no-undef
	tween.to('#target', 1, { rotation: 360 });
	// eslint-disable-next-line no-unused-vars
	const scence2 = new ScrollMagic.Scene({
		triggerElement: '#pre-next', duration: monitor, offset: 0, triggerHook: 1,
	})
		.setTween('#target .agency-card._one', {
			rotation: -16,
			y: -monitor - (document.querySelector('#target .agency-card._one').clientHeight * 3),
			x: 200,
		})
	// .addIndicators({ name: '2 (duration: 300)' })
		.addTo(controller2);

	// eslint-disable-next-line no-unused-vars
	const scence3 = new ScrollMagic.Scene({
		triggerElement: '#pre-next', duration: monitor, offset: 0, triggerHook: 1,
	})
		.setTween('#target .agency-card._two', {
			rotation: 16,
			y: -monitor - (document.querySelector('#target .agency-card._two').clientHeight * 3),
			x: -200,
		})
	// .addIndicators({ name: '2 (duration: 300)' })
		.addTo(controller2);

	// eslint-disable-next-line no-unused-vars
	const scence4 = new ScrollMagic.Scene({
		triggerElement: '#pre-next', duration: monitor, offset: 0, triggerHook: 1,
	})
	.setTween('#target .agency-card._three', {
		rotation: -55,
		y: -monitor - (document.querySelector('#target .agency-card._three').clientHeight * 2),
		x: 100,
	})
	// .addIndicators({ name: '2 (duration: 300)' })
	.addTo(controller2);



	// eslint-disable-next-line no-unused-vars
	const scence5 = new ScrollMagic.Scene({
		triggerElement: '#pre-next', duration: monitor, offset: 0, triggerHook: 1,
	})
	.setTween('#target .agency-card._four', {
		rotation: 37,
		y: -monitor - (document.querySelector('#target .agency-card._four').clientHeight * 2.5),
		x: -100,
	})
	// .addIndicators({ name: '2 (duration: 300)' })
	.addTo(controller2);
}

if (document.querySelector('.request__form .select__box')) {
	const selectParent = document.querySelector('.select__box [data-class="select_js"]');
	const select = new NiceSelect(selectParent, {
		searchable: false,
		placeholder: selectParent.querySelector('[data-display]').textContent,
	});
	const selectClear = document.querySelector('.select__box .select__clear');
	selectClear.addEventListener('click', function () {
		setTimeout(() => {
			select.update();
			selectInit();
		}, 0);
		for (const radio of document.querySelectorAll('input[name="radioGroup"]')) {
			radio.checked = false;
		}
	});

	// eslint-disable-next-line no-inner-declarations
	function selectInit() {
		select.options.forEach((option, index) => {
			const arr = [
				[''],
				['Скринінг DevOps-інженера', 'HR інтервʼю', 'Рекомендація до наймання'],
				['Скринінг DevOps-інженера', 'HR інтервʼю', 'Рекомендація до наймання', 'Технічна співбесіда', 'Перевірка англійської'],
				['Скринінг DevOps-інженера', 'HR інтервʼю', 'Рекомендація до наймання', 'Технічна співбесіда', 'Перевірка англійської', 'Одна безплатна заміна'],
				[''],
			];
			option.element.classList.add('icon-' + index);
			const addition = document.createElement('span');
			const div = document.createElement('div');
			div.setAttribute('class', 'hint _bottom');
			const ul = document.createElement('ul');

			if (index > 0 && index <= 3) {
				arr[index].forEach((element) => {
					const li = document.createElement('li');
					ul.appendChild(li);
					li.innerHTML += element;
					li.prepend(document.createElement('span'));

					if (index === 3) {
						div.setAttribute('class', 'hint _bottom-reverse');
					} else {
						div.setAttribute('class', 'hint _bottom');
					}
					div.appendChild(ul);
					addition.appendChild(div);
				});
			}

			option.element.prepend(addition);
		});
	}

	selectInit();

	// eslint-disable-next-line no-inner-declarations
	function myFunction() {
		const $options = Array.from(selectParent.options);
		const optionToSelect = $options.find((item) => item.value === this.value);
		optionToSelect.selected = true;

		const niceEl = document.querySelector('.select__box .nice-select');
		const niceOptions = Array.from(niceEl.querySelectorAll('.option'));
		const niceLabel = niceEl.querySelector('.current');
		niceOptions.forEach((item) => item.classList.remove('selected', 'focus'));
		const niceOptionsSelect = niceOptions.find((item) => item.getAttribute('data-value') === this.value);
		niceOptionsSelect.classList.add('selected', 'focus');
		niceLabel.innerHTML = niceOptionsSelect.innerHTML;

		niceLabel.className = 'current';
		niceLabel.classList.add('icon-' + selectParent.selectedIndex);
		niceLabel.prepend(document.createElement('span'));
	}

	document.querySelectorAll('input[name="radioGroup"]').forEach((input) => {
		input.addEventListener('change', myFunction);
	});
	selectParent.addEventListener('change', (event) => {
		const niceEl = document.querySelector('.select__box .nice-select');
		const niceLabel = niceEl.querySelector('.current');
		niceLabel.className = 'current';
		niceLabel.classList.add('icon-' + event.target.selectedIndex);
		niceLabel.prepend(document.createElement('span'));

		document.querySelectorAll('input[name="radioGroup"]').forEach((input) => {
			const option = selectParent.selectedOptions;
			if (input.value === option[0].value) {
				// eslint-disable-next-line no-param-reassign
				input.checked = true;
			}
		});
	});
}

// TODO delete
/* function showStages() {
  if (document.querySelector('.stages-selection')) {
    const btn = document.querySelector('[data-show-btn]');
    const block = document.querySelector('.stages-selection');
    btn.addEventListener('click', function () {
      block.classList.toggle('show');
      let offsetTop = null;
      offsetTop = document.querySelector('.stages-selection').offsetTop;
      // eslint-disable-next-line no-restricted-globals,no-undef
      scroll({
        top: offsetTop,
        behavior: 'auto',
      });
    });
  }
} */

function servicesSlider() {
	if (document.querySelector('.services-list')) {
		// eslint-disable-next-line no-unused-vars
		const flktyServices = new Flickity('.services-list', {
			freeScroll: true,
			freeScrollFriction: 0.03,
			contain: true,
			prevNextButtons: false,
			pageDots: false,
			cellAlign: 'left',
			percentPosition: false,
		});
	}
}

function statisticsSlider() {
	if (document.querySelector('.statistics__carousel')) {
		// eslint-disable-next-line no-unused-vars
		const flktyStatistics = new Flickity('.statistics__carousel', {
			freeScroll: false,
			contain: true,
			prevNextButtons: false,
			pageDots: true,
			autoPlay: false,
			wrapAround: true,
		});
		let flktyIsAnimating = false;

		function flickityHandleWheelEvent(e, flickityInstance, flickityIsAnimating) {
			if (!flickityIsAnimating) {
				const direction = (Math.abs(e.deltaX) > Math.abs(e.deltaY)) ? e.deltaX : e.deltaY;
				if (direction > 0) {
					flickityInstance.next();
				} else {
					flickityInstance.previous();
				}
			}
		}

		flktyStatistics.on('settle', function () {
			flktyIsAnimating = false;
		});

		flktyStatistics.on('select', function () {
			flktyIsAnimating = true;
		});

		document.querySelector('.statistics__carousel').onwheel = function (e) {
			e.preventDefault();
			flickityHandleWheelEvent(e, flktyStatistics, flktyIsAnimating);
		};
	}
}

function dropdownBlock() {
    const dropdown = document.querySelectorAll('[data-name="dropdown"]');
    const dropdownItem = document.querySelectorAll('[data-name="dropdownItem"]');
    const html = document.querySelector('html');

    Array.prototype.forEach.call(dropdown, function (elDropdown) {
        elDropdown.addEventListener('click', (event) => {
            event.stopImmediatePropagation();
            if (elDropdown.classList.contains('open')) {
                elDropdown.classList.remove('open');
            } else {
                elDropdown.classList.add('open');
            }
        });
    });
    html.addEventListener('click', () => {
        Array.prototype.forEach.call(dropdown, function (elDropdown) {
            elDropdown.classList.remove('open');
        });
    });
    Array.prototype.forEach.call(dropdownItem, function (elDropdownItem) {
        elDropdownItem.addEventListener('click', (event) => {
            for (const el of dropdownItem) {
                el.classList.remove('active');
            }
            event.target.parentNode.classList.add('active');
            // eslint-disable-next-line no-param-reassign
            elDropdownItem.closest('[data-name="dropdown"]').querySelector('span > span').textContent = `${event.target.childNodes[0].textContent}`;
        });
    });
}

function preferenceSlide() {
	if (document.querySelector('.preference-carousel')) {
		const carouselStatus = document.querySelector('.carousel-status');
		if (window.innerWidth <= 991) {
			// eslint-disable-next-line no-unused-vars
			const flktyPreference = new Flickity('.preference-carousel', {
				freeScroll: false,
				contain: true,
				prevNextButtons: false,
				pageDots: false,
				cellSelector: '.preference__item__slide',
			});
			if (carouselStatus) {
				// eslint-disable-next-line no-inner-declarations
				function updateStatus() {
					const slideNumber = flktyPreference.selectedIndex + 1;
					carouselStatus.innerHTML = `<b>0${slideNumber}  /</b> 0${flktyPreference.slides.length}`;
				}

				updateStatus();
				flktyPreference.on('select', updateStatus);
			}
			const nextButton = document.querySelector('.slider-mobile .arrow_next');
			if (nextButton) {
				nextButton.addEventListener('click', function (e) {
					flktyPreference.next();
					e.stopImmediatePropagation();
				});
			}
			const previousButton = document.querySelector('.slider-mobile .arrow_prev');
			if (previousButton) {
				previousButton.addEventListener('click', function (e) {
					flktyPreference.previous();
					e.stopImmediatePropagation();
				});
			}

			// eslint-disable-next-line no-inner-declarations
			function disabledButton() {
				// enable/disable previous/next buttons
				if (!flktyPreference.slides[flktyPreference.selectedIndex - 1]) {
					previousButton.classList.add('disabled');
					nextButton.classList.remove('disabled');
				} else if (!flktyPreference.slides[flktyPreference.selectedIndex + 1]) {
					nextButton.classList.add('disabled');
					previousButton.classList.remove('disabled');
				} else {
					previousButton.classList.remove('disabled');
					nextButton.classList.remove('disabled');
				}
			}

			flktyPreference.on('ready', setTimeout(() => disabledButton(), 300));
			flktyPreference.on('select', disabledButton);
		} else {
			new Flickity('.preference-carousel').destroy();
			if (carouselStatus) {
				carouselStatus.innerHTML = '';
			}
		}
	}
}

function mobileMenu() {
	const hamburger = document.querySelectorAll('.hamburger');
	const fader = document.querySelectorAll('.fader');
	const html = document.querySelector('html');

	Array.prototype.forEach.call(hamburger, function (elHamburger) {
		elHamburger.addEventListener('click', function () {
			html.classList.toggle('menu-opened');
			return false;
		});
	});
	Array.prototype.forEach.call(fader, function (elFader) {
		elFader.addEventListener('click', function () {
			html.classList.remove('menu-opened');
		});
	});
}

function toggleMenuItem() {
	setTimeout(() => {
		// Helper function
		function addListenerToElement(element, eventType, listener) {
			element.addEventListener(eventType, listener);
		}

		// Add "active" class to clicked element, remove it from siblings and toggle show in sub-menus
		function toggleActiveClass() {
			const dropDown = this.nextElementSibling;

			this.parentElement.classList.toggle('current-menu-item');
			if (dropDown !== null) {
				dropDown.classList.toggle('_show');
				if (dropDown.classList.contains('_show')) {
					dropDown.style.maxHeight = dropDown.scrollHeight + 'px';
				} else {
					dropDown.style.maxHeight = '0px';
				}
			}
			return false;
		}

		const menuItems = document.querySelectorAll('[data-name="openerLink"]');
		for (const value of menuItems) {
			value.addEventListener('click', (e) => {
				if (e.target.parentNode.classList.contains('disabled-link')) {
					e.preventDefault();
				}
			});
			addListenerToElement(value, 'click', toggleActiveClass);
		}

		const hamburger = document.querySelector('.hamburger');
		if (hamburger) {
			hamburger.addEventListener('click', () => {
				for (const value of menuItems) {
					if (value.parentElement.classList.contains('current-menu-item')) {
						value.parentElement.classList.remove('current-menu-item');
						value.nextElementSibling.classList.remove('_show');
						value.nextElementSibling.style.maxHeight = '0px';
					}
				}
				return false;
			});
		}
	}, 1000);
}

function blockToTop(el) {
	if (el) {
		const action = () => {
			// console.log('window.pageYOffset = ', window.pageYOffset);
			// console.log('el.offsetTop       = ', el.offsetTop);
			const currentScrollPos = window.pageYOffset;
			if (currentScrollPos >= el.offsetTop) {
				el.classList.add('fixedToTop');
			} else if(currentScrollPos <= el.offsetTop - 300) {
				el.classList.remove('fixedToTop');
			}
		};

		action();

		window.addEventListener('scroll', function () {
			action();
		})
	}
}

function headerFixedClass() {
	if (document.querySelector('.single-page') && document.querySelector('.header-page')) {
		const el = document.querySelector('.single-page .visual');
		const height = 0;
		const header = document.querySelector('.header-page');
		let heightEl = 0;
		if (el) {
			setTimeout(() => {
				heightEl = document.querySelector('.single-page .visual').clientHeight - header.offsetHeight;
			}, 300);
		}

		(window.pageYOffset > heightEl) ? header.classList.add('modify') : header.classList.remove('modify');
		if (el) {
			(window.pageYOffset > height) ? el.classList.add('scrolled') : el.classList.remove('scrolled');
		}
		window.addEventListener('scroll', function () {
			(window.pageYOffset > heightEl) ? header.classList.add('modify') : header.classList.remove('modify');
			if (el) {
				(window.pageYOffset > height) ? el.classList.add('scrolled') : el.classList.remove('scrolled');
			}
		});
	}

	let prevScrollpos = window.pageYOffset;
	const headerDiv = document.querySelector('.header-page');

	let heightEl = 0;
	if (document.querySelector('.single-page .visual')) {
		setTimeout(() => {
			heightEl = document.querySelector('.single-page .visual').clientHeight - headerDiv.offsetHeight;
		}, 300);
	}

	(window.pageYOffset > heightEl) ? headerDiv.classList.add('modify') : headerDiv.classList.remove('modify');

	window.onscroll = function () {
		const currentScrollPos = window.pageYOffset;
		if (prevScrollpos <= currentScrollPos) {
			headerDiv.classList.remove('fixedToTop');
		} else {
			headerDiv.classList.add('fixedToTop');
		}

		(window.pageYOffset > heightEl) ? headerDiv.classList.add('modify') : headerDiv.classList.remove('modify');
		prevScrollpos = currentScrollPos;
	};
}

window.onload = function () {
	servicesSlider();
	statisticsSlider();
	preferenceSlide();

	const loadTime = window.performance.timing.domContentLoadedEventEnd - window.performance.timing.navigationStart;
	if (document.querySelector('.preloader')) {
		setTimeout(function () {
			if (document.querySelector('.wrapper').classList.contains('single-page')) {
				document.querySelector('.wrapper').classList.add('loaded');
			}
			setTimeout(function () {
				document.querySelector('.preloader').classList.add('hide');
				document.querySelector('.preloader').classList.remove('show');
			}, 0);
		}, loadTime);
	}
	if (document.querySelector('.visual')) {
		setTimeout(function () {
			document.querySelector('.visual').classList.add('start');
		}, loadTime + 100);
	}
};

function formEffect() {
	const control = document.querySelectorAll('.form .form__control');
	if (control.length) {
		Array.prototype.forEach.call(control, function (el) {
			if (el.value.length >= 1) {
				el.parentNode.classList.add('input--filled');
			}
		});
	}
	Array.prototype.forEach.call(control, function (el) {
		el.addEventListener('focusin', myFocusinFunction);
		el.addEventListener('focusout', myFocusoutFunction, true);
		el.addEventListener('input', myOninputFunction, true);
	});

	// eslint-disable-next-line no-shadow
	function myFocusinFunction(control) {
		control.target.parentNode.classList.add('input--filled');
		control.target.parentNode.classList.add('input--focus');
	}

	// eslint-disable-next-line no-shadow
	function myFocusoutFunction(control) {
		if (control.target.value.length <= 0) {
			control.target.parentNode.classList.remove('input--filled');
		}
		control.target.parentNode.classList.remove('input--focus');
	}

	// eslint-disable-next-line no-shadow
	function myOninputFunction(control) {
		if (control.target.value.length > 1) {
			control.target.parentNode.classList.add('input--filled');
		}
	}

	const phonesControl = document.querySelectorAll('.form__control_phone');
	phonesControl.forEach((phone) => {
		const phoneMask = IMask(phone, {
			mask: '+{38} (000) 000 00 00',
			lazy: true,
			placeholderChar: '_',
		});
		phone.addEventListener('focus', function () {
			phoneMask.updateOptions({ lazy: false });
		}, true);
		phone.addEventListener('blur', function () {
			phoneMask.updateOptions({ lazy: true });
			if (!phoneMask.masked.rawInputValue) {
				phoneMask.value = '';
			}
		}, true);
	});
}

function anchor() {
	if (document.querySelector('.anchor')) {
		// eslint-disable-next-line no-shadow
		const anchor = document.querySelectorAll('.anchor');

		for (const value of anchor) {
			// eslint-disable-next-line no-loop-func
			value.addEventListener('click', function (event) {
				const prevScrollpos = window.pageYOffset;
				const html = document.querySelector('html');
				html.classList.remove('menu-opened');
				const href = this.getAttribute('href');
				let offsetTop = null;
				if (prevScrollpos >= 1000 && window.innerWidth >= 991) {
					offsetTop = href === '#' ? 0 : document.querySelector(href).offsetTop;
				} else if (prevScrollpos <= 1000 && window.innerWidth >= 991) {
					offsetTop = href === '#' ? 0 : document.querySelector(href).offsetTop - document.querySelector('.single-page .visual').clientHeight;
				} else if (window.innerWidth < 991) {
					offsetTop = href === '#' ? 0 : document.querySelector(href).offsetTop;
				}

				// eslint-disable-next-line no-restricted-globals,no-undef
				scroll({
					top: offsetTop,
					behavior: 'smooth',
				});
				event.preventDefault();
			});
		}
	}
}

function tabs() {
	const myTabs = document.querySelectorAll('[data-name="tabs-item"]');

	function myTabClicks(tabClickEvent) {
		for (let i = 0; i < myTabs.length; i++) {
			myTabs[i].classList.remove('_active');
		}
		const clickedTab = tabClickEvent.currentTarget;
		clickedTab.classList.add('_active');
		tabClickEvent.preventDefault();
		const myContentPanes = document.querySelectorAll('[data-name="tabs-panel"]');
		for (let j = 0; j < myContentPanes.length; j++) {
			myContentPanes[j].classList.remove('_active');
		}
		const anchorReference = this.querySelector('[data-name="tabs-link"]');
		const activePaneId = anchorReference.getAttribute('href');
		const activePane = document.querySelector(activePaneId);
		activePane.classList.add('_active');
	}

	for (let q = 0; q < myTabs.length; q++) {
		myTabs[q].addEventListener('click', myTabClicks);
	}
}

(function () {
	document.addEventListener('DOMContentLoaded', () => {
		setTimeout(OnScroll, 300);
	});
	if (window.location.hash) {
		window.hash = window.location.hash.substr(1);
		window.location.hash = '';
	}

	function OnScroll() {
		if (window.hash) {
			let offsetTop = null;
			offsetTop = document.querySelector(`#${window.hash}`).offsetTop;
			// eslint-disable-next-line no-restricted-globals,no-undef
			scroll({
				top: offsetTop,
				behavior: 'smooth',
			});
		}
	}
}(window));
